<template>
<section>
    <!-- <v-server-table
           ref="lineTowerTable"
                url
                :limit="5"
                :columns="columns"
                :options="options"
                @loaded="onLoaded">
                </v-server-table> -->

    <div v-if="lineView" class="">
        <!-- <div class=""> -->
            <!-- <div class=""></div> -->
            <div id="details" class="overlay">
                <div class="overlay_inner">
                    <div class="form-modal">
                        <h4>Add / Update Line/Tower</h4>
                        <vue-form :state="formstate" class="formadd_scroll">
                            <div class="row">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.name)">
                                        <label>Line / Tower Name</label>
                                        <input type="text" name="cdaName" class="form-control" required v-model="line.name" placeholder="Line / Tower Name" maxlength="45" pattern="^[A-Za-z0-9].{0,44}$" />
                                        <field-messages name="cdaName" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">
                                                Line / Tower is required.
                                            </div>
                                            <div slot="pattern">
                                                Alphabets/Numbers are allowed.
                                            </div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div>
                                <label>Houses<span class="required-field-asterisk">*</span>
                                </label>
                            </div>
                            <div class="houses_wrp">
                                <div class="flex house_number_wrp" v-for="(house, houseIndex) in line.houseData" :key="houseIndex">
                                    <div class="house_number_boxs">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.houses)">
                                            <input type="text" class="form-control" v-model="house.hnNo" required placeholder="H No." :name="
                                'line.houseData[' + houseIndex + '][\'hnNo\']'
                              " maxlength="15" pattern="^[a-zA-Z0-9\s]{0,25}[^\s]$" />
                                            <field-messages :name="
                                'line.houseData[' + houseIndex + '][\'hnNo\']'
                              " show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">
                                                    House number is required.
                                                </div>
                                                <div slot="pattern">
                                                Alphabets/Numbers are allowed.
                                            </div>
                                                <!-- <div slot="pattern">
                                Houses should be of maximum 15 characters.
                              </div> -->
                                            </field-messages>
                                            <!-- <div v-if="house.hnNo == ''" class="input-error">
                                                          Houses is a required field.
                                                      </div> -->
                                        </validate>
                                    </div>
                                    <button type="button" v-if="subCityAdmin" class="mr-2 btn gradientbt" @click="removeHouse(houseIndex)" v-show="line.houseData.length > 1">
                                        -
                                    </button>
                                </div>
                                <button type="button" class="mr-2 btn gradientbt addmorebtn" @click="addMoreHouses()" :disabled="(!formstate.$valid) && houseList">
                                    +
                                </button>
                            </div>
                        </vue-form>
                        <div class="form-actions">
                            <button @click="onClose" v-bind:class="'mr-5  btn btn-default'">
                                Cancel
                            </button>
                            <button v-if="mode == 'create'" type="submit" @click="createLine" :disabled="!(formstate.$dirty && formstate.$valid)" v-bind:class="'mr-2 btn gradientbt'">
                                Add
                            </button>
                            <button v-if="mode == 'edit'" type="submit" @click="updateLine" :disabled="
                        !(
                          (formstate.$dirty || isRemoveButtonClicked) &&
                          formstate.$valid
                        )
                      " v-bind:class="'mr-2 btn gradientbt'">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </div> -->
    </div>
    <div v-if="$route.params._id && !noRecords">
        <div class="col-sm-12">
            <div class="large-12 columns subcattable" style="background:white;">
                <table class="test-table">
                    <tr>
                        <th>Line / Tower</th>
                        <th>Houses</th>
                        <th>Action</th>
                    </tr>
                    <tr v-for="(item, index) in lineInfo" :key="index">
                        <td>{{ item.name }}</td>
                        <td>{{ item.houseData.length }}</td>
                        <td>
                            <button class="button edit_del_btn">
                                <i class="fa fa-pencil-square-o" v-on:click="editLine(index, item)"></i>
                            </button>
                            <button class="button edit_del_btn" v-if="subCityAdmin">
                                <i class="fa fa-trash-o" @click="deleteLineModal(item._id)"></i>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
    <div class="col-sm-12">
        <div v-if="$route.params._id && noRecords">
            <h6>No matching records</h6>
        </div>
        <button class="text-right add_subcategory" @click="addLine()">
            Add Line / Tower
        </button>
    </div>
</section>
</template>

  
  
<script>
import {
    error,
    log
} from "console";
// import { defineComponent } from '@vue/composition-api'
import {
    formService,
    eventBus,
    wasteCollectionAreaService,
} from "../../../services";
import swal from "sweetalert2";

export default {
    name: "lineTowerList",
    data() {
        return {
            isRemoveButtonClicked: false,
            subCityAdmin:true,
            loading: false,
            collectionId: "",
            lineInfo: null,
            lineNames:[],
            selectedLineName:"",
            lineTowerTable: null,
            noRecords: false,
            lineView: false,
            mode: "create",
            formstate: {},
            __id: "",
            cdId: "",
            line: {
                name: "",
                houseData: [{
                    hnNo: "",
                }, ],
            },
            columns: ["tower", "houses", "action"],
            houseList: true,

            options: {
                headings: {
                    tower: "Tower Name",
                    houses: "Houses",
                },
            },
        };
    },

    methods: {
        fieldClassName: formService.fieldClassName,
        getLineTowernById() {
            this.lineNames = [];
            this.loading = true;
            return wasteCollectionAreaService
                .getCollectionDivisionById(this.$route.params._id)
                .then((response) => {
                    this.collectionId = response.data.response._id;
                    this.lineInfo = response.data.response;
                    this.lineNames = this.lineInfo.map(element => element.name)
                    if (response.data.response.length > 0) {
                        this.noRecords = false;
                    } else {
                        this.noRecords = true;
                    }
                })
                .catch((error) => {
                    this.$snotify.error(error.message, "Error!");
                });
        },
        addMoreHouses() {
            this.houseList = true;
            this.line.houseData.push({
                hnNo: "",
            });
        },
        removeHouse(houseIndex) {
            this.line.houseData.splice(houseIndex, 1);
            this.isRemoveButtonClicked = true;
            if (houseIndex > 1) {
                this.houseList = false;
            } else {
                this.houseList = true;
            }
        },

        deleteLineModal(id) {
            swal({
                title: "Are you sure you want to delete?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                customClass: "swal-modal2",
                width: "400px",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.deleteLine(id);
                }
            });
        },
        deleteLine(id) {
            this.loading = true;
            return wasteCollectionAreaService
                .deleteLine(id)
                .then((response) => {
                    this.loading = false;
                    this.$snotify.success(`The Line has been deleted successfully.`);
                    this.getLineTowernById();
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error.data.message, "Error!");
                });
        },

        addLine() {
            this.line = {
                name: "",
                houseData: [{
                    hnNo: "",
                }, ],
            };
            this.lineView = true;
        },

        createLine() {
            let lineData = {};
            lineData["cdId"] = this.$route.params._id;
            lineData["name"] = this.line["name"];
            // lineData["_id"] = this.__id
            lineData["houses"] = this.line["houseData"];

            return wasteCollectionAreaService
                .addLine(lineData)
                .then((response) => {
                    this.loading = false;
                    this.$snotify.success("Line added!", "Success!");
                    this.lineView = false;
                    this.mode = "create";
                    this.getLineTowernById();
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error.data.message, "Error!");
                });
        },

        editLine(index, data) {
            this.selectedLineName = data.name
            if (data.houseData.length > 0) {
                this.houseList = false;
            } else {
                this.houseList = true;
            }
            this.lineView = true;
            this.mode = "edit";
            this.line = JSON.parse(JSON.stringify(data));
            this.isRemoveButtonClicked = false;
            // this.cdId = data.divisionId;
            this.__id = data._id;
        },

        updateLine() {
            this.loading = true;
            if(this.selectedLineName != this.line["name"]){
                if(!this.lineNames.includes(this.line["name"]) ){
                    this.onUpdate()
                } else{
                    this.$snotify.error(`Line / Tower ${this.line["name"]} already exists`, "Error!");
                } 
            }else{
                this.onUpdate()
            }
        },

        onUpdate(){

            let lineData = {};
                lineData["cdId"] = this.$route.params._id;
                lineData["name"] = this.line["name"];
                lineData["_id"] = this.__id;
                lineData["houses"] = [];
                for (let item = 0; item < this.line.houseData.length; item++) {
                    let house = {};
                    house.hnNo = this.line.houseData[item]["hnNo"];
                    house._id = this.line.houseData[item]["_id"] ? this.line.houseData[item]["_id"] : "";
                    lineData["houses"].push(house);
                }
                return wasteCollectionAreaService
                    .updateLine(lineData)
                    .then((response) => {
                        this.loading = false;
                        this.$snotify.success("Line updated!", "Success!");
                        this.lineView = false;
                        this.mode = "create";
                        this.getLineTowernById();
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.$snotify.error(error.data.message, "Error!");
                    });

        },




        
        onClose() {
            this.lineView = false;
            this.mode = "create";
            // this.formstate._reset()
        },

        onLoaded() {
            this.lineTowerTable = this.$refs.lineTowerTable;
        },
    },
    mounted(){
            if (this.$store.state.auth.user.role.key === "subCityAdmin") {
            this.subCityAdmin = false
        }
    },
    created() {
        const promises = [];
        this.loading = true;

        if (this.$route.params && this.$route.params._id) {
            promises.push(this.getLineTowernById());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
    },
};
</script>
  
  
<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #35A2FE;
    color: white;
}

.add_del_btn_wrp {
    z-index: 1;
}

.del_btn {
    cursor: pointer;
    width: fit-content;
    background: #35A2FE;
    color: #fff;
    border: #35A2FE;
}

.col-sm-4.del_btn_rel {
    padding-right: 30px;
}

.del_btn svg {
    height: 10px;
    width: 10px;
    cursor: pointer;
}

.add_del_btn_wrp .add_btn {
    background: #35A2FE;
    color: #fff;
    border: #35A2FE;
    padding: 9px;
    cursor: pointer;
}

body {
    background-color: lightgray;
}

table {
    width: 100%;
}

td form {
    margin: 0;
    padding: 0;
}

td form button.button {
    padding: 0.25em;
    margin: 0.25em;
    background: none;
    color: blue;
}

td form button.button:hover {
    background: none;
    color: steelblue;
}

.test-table {
    margin-left: 80px;
}

.del_btn_rel_flex {
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
}

.del_btn_rel_inner {
    flex: 0 0 31%;
    margin-right: 15px;
    position: relative;
    padding-right: 30px;
}

.del_btn_wrp {
    position: absolute;
    right: 0;
    top: 0;
    padding: 3px 12px;
    border-radius: 5px;
    font-size: 20px;
}

.sub_category_paddi {
    padding: 0px 15px;
    height: calc(100vh - 330px);
    overflow: auto;
    overflow-x: hidden;
}

.sub_category_paddi::-webkit-scrollbar {
    width: 5px;
}

.sub_category_paddi::-webkit-scrollbar-thumb {
    background: #888;
}

.subcattable table {
    margin-left: 0px;
}

.subcattable table td,
.subcattable table th {
    border: 1px solid #f4f4f4;
}
.subcattable table tr:nth-of-type(1) {
    background-color: #5f9dfe !important;
}
/* .subcattable table tr:nth-of-type(odd) {
    background-color: #f9f9f9;
} */

/* .subcattable table tr:hover {
    background-color: #5e9cfe29 !important;
} */

.edit_del_btn {
    border: 0;
    background-color: transparent;
    color: #35A2FE;
}

.subcattable table tr td:last-child {
    width: 200px;
}

.add_subcategory {
    background: #35A2FE;
    border: 2px solid #35A2FE;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-top: 15px;
}

.sub_boxs {
    box-shadow: none;
}

.toggle_icon {
    --width: 64px;
    --height: calc(var(--width) / 3);
    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: none;
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: absolute;
    top: 10px;
    right: -15px;
}

.toggle_icon svg {
    width: 15px;
    height: 15px;
}

.overlay {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.form-modal {
    background: #fff;
    width: 60%;
    transform: initial;
    padding: 0;
}

.overlay_inner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.flex.house_number_wrp {
    display: flex;
    align-items: baseline;
    flex: 0 0 15%;
    margin-right: 10px;
    margin-top: 15px;
}

.houses_wrp {
    display: flex;
    flex-wrap: wrap;
}

.formadd_scroll {
    height: 290px;
    overflow: auto;
    overflow-x: hidden;
    padding: 15px;
}

.formadd_scroll::-webkit-scrollbar {
    width: 5px;
}

.formadd_scroll::-webkit-scrollbar-thumb {
    background: #888;
}

.input-error {
    color: #dd4b39;
}

.house_number_wrp .form-group {
    margin-bottom: 0;
}

.houses_wrp .addmorebtn {
    margin-top: 15px;
    height: 34px;
}

.overlay_inner .form-actions {
    text-align: right;
    padding: 20px 15px;
    border-top: 1px solid #ddd;
}

.overlay_inner .form-modal h4 {
    background: #f1f1f1;
    padding: 20px;
    margin: 0;
    border-bottom: 1px solid #ddd;
}

.required-field-asterisk {
    color: red;
    margin-left: 0.25rem;
}

.row_paddi_manage {
    margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// lineTowerList.vue?6e35da30